// src/utils/uploadHandler.js
import { writeBatch, doc, collection, serverTimestamp } from "firebase/firestore";
import { db } from '../firebase';

const readFileContent = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => resolve(event.target.result);
    reader.onerror = (error) => reject(error);
    reader.readAsText(file);
  });
};

const parseTSV = (content) => {
  const lines = content.split('\n');
  const headers = lines[0].split('\t').map(header => header.trim());
  
  // Find the index of the 'Topic' column
  const topicIndex = headers.findIndex(header => 
    header.toLowerCase() === 'topic' || header.toLowerCase() === 'category');
  
  if (topicIndex === -1) {
    throw new Error("TSV file must include a 'Topic' or 'Category' column");
  }

  return lines.slice(1).map(line => {
    const values = line.split('\t');
    const item = {};
    headers.forEach((header, index) => {
      item[header] = values[index]?.trim() || '';
    });
    
    // Ensure 'Topic' is always present and capitalized correctly
    item.Topic = item[headers[topicIndex]] || 'Uncategorized';
    
    return item;
  });
};


const validateFile = (parsedData, fileType) => {
  const expectedFields = {
    utterances: 2,
    faqs: 3,
    answers: 2
  };

  if (parsedData.length === 0) {
    throw new Error('The file is empty.');
  }

  const firstRow = parsedData[0];
  const fieldsCount = Object.keys(firstRow).length;

  if (fieldsCount !== expectedFields[fileType]) {
    throw new Error(`Invalid number of fields. Expected ${expectedFields[fileType]} for ${fileType}, but got ${fieldsCount}.`);
  }
};

const batchUpload = async (data, collectionName) => {
  const batch = writeBatch(db);
  data.forEach((item) => {
    const newDocRef = doc(collection(db, collectionName));
    batch.set(newDocRef, {
      ...item,
      Topic: item.Topic || 'Uncategorized', // Ensure Topic is set
      addedAt: serverTimestamp()
    });
  });
  await batch.commit();
};

export const handleUpload = async (file, fileType) => {
  try {
    const content = await readFileContent(file);
    const parsedData = parseTSV(content);
    
    validateFile(parsedData, fileType);

    await batchUpload(parsedData, fileType);
  } catch (error) {
    console.error("Upload error:", error);
    throw error;
  }
};
